import { MoreOutlined } from '@ant-design/icons';
import { Dropdown, MenuProps } from 'antd';
import { memo } from 'react';
import { DataStateItem } from 'shared/types';

export interface TableAction {
  label: string
  onClick: (record: DataStateItem) => void
  isActive?: (record: DataStateItem) => boolean
}

export interface TableActions {
  actions: TableAction[]
  record: DataStateItem
}

const TableActionsComponent: React.FC<TableActions> = ({ actions, record }) => {
  const menuItems: MenuProps['items'] = actions
    .filter((action) => (action.isActive ? action.isActive(record) : true))
    .map((item, index) => (
      {
        key: index,
        label: (
          <a onClick={() => item.onClick(record)}>
            {item.label}
          </a>
        ),
      }));
  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomLeft">
      <MoreOutlined style={{ fontSize: 22 }} />
    </Dropdown>
  );
};

export const TableActions = memo(TableActionsComponent);
